// extracted by mini-css-extract-plugin
export var active = "_co-2";
export var recordingDot = "_co-1";
export var recordingIndicator = "_co-0";